import { normalizeElementProperty } from '@/common/normalize/normalize-element-property'
import { normalizeContextProperty } from '@/common/normalize/normalize-context-property'
import { normalizeElementAction } from '@/common/normalize/normalize-element-action'

export const normalizeElement = (rawData) => {
  const {
    type = '', // container | title | button
    property = {},
    action_list: actionList = [],
    context_property: contextProperty = {},
    context_action_list: contextActionList = [],
    top_context_action_list: topContextActionList = [],
  } = rawData

  return {
    type,
    property: normalizeElementProperty(property),
    actionList: actionList?.map(normalizeElementAction),
    contextActionList: contextActionList?.map(normalizeElementAction),
    contextProperty: normalizeContextProperty(contextProperty),
    topContextActionList: topContextActionList?.map(normalizeElementAction),
  }
}
